import React from 'react';

export const passwordContext = React.createContext('');

type PasswordProviderProps = {
   fetchUrl: string;
   children: React.ReactNode;
};

export const PasswordProvider = ({fetchUrl, children}: PasswordProviderProps) => {
   const {Provider} = passwordContext;
   return <Provider value={fetchUrl}>{children}</Provider>;
};
